import * as React from "react";
import {
    BlindsStructure, ListBlindsStructureRequest
} from "../../../../../generated/protocol";
import {EntityDataTable} from "../../../list/EntityDataTable";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../../ListView";
import {kernel} from "../../../../ioc/IOCHelper";
import {ActionType} from "../../../list/DataTable";
import {BlindsStructureService} from "../../../../service/poker/tournament/BlindsStructureService";
import {Symbols} from "../../../../ioc/Symbols";
import {Link} from "react-router";


interface FilterForm {
    currencyCode?: string;
    operatorId?: number;
    archived?: boolean;
}

interface State extends ListViewState<ListBlindsStructureRequest> {
    listRequest?: ListBlindsStructureRequest;
    form?: FilterForm;
    validationMap?: any;
}

export class BlindsStructureListView extends ListView<State, ListBlindsStructureRequest> {


    service: BlindsStructureService;


    columns = [
        {property: "id", name: "ID"},
        {property: "name", name: "Name"}
    ];
    actions = [
        {
            id: "copy",
            name: "Copy",
            className: "btn btn-primary",
            iconClassName: "fa fa-copy",
            type: ActionType.LINK,
            getLink: (item) => "/tournament-structures/blind/new/" + item.id
        },
        {
            id: "edit",
            name: "Edit",
            className: "btn btn-warning",
            iconClassName: "fa fa-edit",
            type: ActionType.LINK,
            getLink: (item) => "/tournament-structures/blind/" + item.id
        },
        {
            id: "delete",
            name: "Delete",
            className: "btn btn-danger",
            iconClassName: "fa fa-times",
            type: ActionType.CONFIRMATION,
        },
    ];

    constructor(props: ListViewProps) {
        super(props, "/tournament-structures/blinds");
        this.state = createInitialState({orderBy: "id"}, this.state);
        this.service = kernel.get<BlindsStructureService>(Symbols.BlindsStructureService);
    }


    onAction(item: BlindsStructure, action: string) {
        if (action == "delete") {
            return this.service.deleteBlindsStructure(item.id);
        }
    }

    renderContent() {

        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Blinds Structures</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <Link className="btn btn-primary" to="/tournament-structures/blind/new">Create Blinds
                                Structure</Link>
                        </div>
                    </div>

                    <EntityDataTable
                        service={this.service}
                        columns={this.columns}
                        actions={this.actions}
                        listRequest={this.state.listRequest}
                        onPagerChange={this.pagerChanged.bind(this)}
                        onAction={this.onAction.bind(this)}/>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/poker/tournament/BlindsStructureListView.tsx